import http from "../../backend/http.js";

async function getDocumentBlock(id) {
  try {
    const response = await http.get(`document-blocks/${id}`);
    return {
      id: response.data.id,
      mainBlockId: response.data.mainBlockId,
      tags: response.data.tags,
      content: response.data.content,
      date: response.data.date,
      updateDate: response.data.updateDate,
      version: response.data.version,
      author: {
        id: response.data.author.id,
        title: response.data.author.title,
      },
      updater: response.data.updater
        ? {
          id: response.data.updater.id,
          title: response.data.updater.title,
        }
        : null,
    };
  } catch (err) {
    throw err;
  }
}

async function createDocumentBlock(block) {
  try {
    const response = await http.post("document-blocks", block);
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function updateDocumentBlock(id, block) {
  try {
    const response = await http.patch(`document-blocks/${id}`, block);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createDocumentBlockVersion(version) {
  try {
    const response = await http.post("document-blocks/versions", version);
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function getBlocks(page = 1, rowsPerPage = 9, filter = "") {
  try {
    const response = await http.get(
      `document-blocks?page=${page}&pageSize=${rowsPerPage}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function unblockUpdate(id) {
  try {
    const response = await http.patch(
      `document-blocks/${id}/rpc/unblock-update`
    );
    return response;
  } catch (err) {
    throw err;
  }
}

async function getDocumentBlockVersions(id, dateFrom) {
  try {
    const response = await http.get(`document-blocks/${id}/versions`, {
      params: {
        from: dateFrom,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

export {
  getBlocks,
  getDocumentBlock,
  createDocumentBlock,
  updateDocumentBlock,
  createDocumentBlockVersion,
  unblockUpdate,
  getDocumentBlockVersions,
};
